import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '@/core/constants/routes';
import { useOpenTask } from '../hooks/useOpenTask';

/**
 * Deep-link entry point (e.g. from a notification email): `/:orgId/tasks/:taskId`.
 *
 * `GlobalTaskDialog` is mounted as a sibling of the route outlet, at the same
 * level as every `/:orgId/...` page, so opening the task here doesn't depend on
 * knowing its project/board — it renders on top of wherever we redirect to.
 */
export default function TaskRedirectPage() {
  const { orgId, taskId } = useParams<{ orgId: string; taskId: string }>();
  const navigate = useNavigate();
  const openTask = useOpenTask();

  useEffect(() => {
    if (taskId) openTask(taskId);
    if (orgId) navigate(ROUTES.tenantDashboard(orgId), { replace: true });
  }, [taskId, orgId, openTask, navigate]);

  return null;
}
